import { useLocation } from '../../dwouter';
import { getQueryParamValueFrom } from '../../utils/url';

export const useLocationQueryParam = paramName => {
  const [{ search }] = useLocation();

  return getQueryParamValueFrom({ from: search, value: paramName });
};
